import styled from 'styled-components';

// const StyledListHorizontal = styled.div`
// 	display: flex;
// 	gap: 20px;

// 	*:not(:first-child):before {
// 		content: '';
// 		display: inline-block;
// 		position: relative;
// 		/* height: 6px; */
// 		/* width: 6px; */
// 		padding: 3px;
// 		border-radius: 50%;
// 		margin-right: 20px;
// 		/* vertical-align: calc(50% - 6px); */
// 		background-color: rgba(255, 255, 255, 0.1);
// 	}
// `;

const StyledListContainer = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
`;

const StyledListDot = styled.span`
	padding: 3px;
	border-radius: 50%;
	background-color: rgba(255, 255, 255, 0.5);
`;

export { StyledListContainer, StyledListDot };
